<div class="view-wrapper">
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
    <div class="dx-card responsive-paddings">
        <dx-toolbar [class]="isContentScrolled ? 'header-toolbar-scrolled' : 'header-toolbar'"
            [class.scrolled]="isContentScrolled">
            <dxi-item location="before">
                <div class="header-text">Ledger Dashboard</div>
            </dxi-item>
        </dx-toolbar>
        

            <div class="cards-container">
                <div class="cards grey" *ngIf="this.cardDataValues.length > 0">
                    <div
                        *ngFor="let card of this.cardDataValues | orderBy:'titleText':['Trust', 'Business', 'Disbursement', 'Card','Merchants']">
                        <app-data-information-card [icon]="card.icon" [titleText]="card.titleText"
                            [data]="card"></app-data-information-card>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="header-buttons" hidden>
                    <dx-button [ariaSetSize]="5" stylingMode="outlined" text="X" type="danger"
                        (click)="clearAllFilters()">

                    </dx-button>
                </div>
                <dx-data-grid id="ledgerTransactionsGrid" [rowAlternationEnabled]="true"
                    [dataSource]="ledgerTransactionDataSource" [remoteOperations]="{
                        filtering: true,
                        grouping: true,
                        groupPaging: false,
                        paging: true,
                        sorting: true,
                        summary: false }"
                      height="'auto'"
                      [allowColumnResizing]="true"
                      [columnAutoWidth]="true"
                      [width]="'100%'"
                      [showBorders]="true"
                      [showColumnLines]="true"
                      [showRowLines]="true"
                      (onCellPrepared)="onCellPrepared($event)"
                      (onExporting)="onExporting($event)"
                    >
                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                    <dxo-filter-row
                      [visible]="true"
                      [applyFilter]="{key: 'auto',name: 'Immediately'}">
                    </dxo-filter-row>
                    <dxo-paging [pageSize]="20"></dxo-paging>
                    <dxo-pager [visible]="true" [showPageSizeSelector]="true"
                        [allowedPageSizes]="[5,10,20, 25, 50, 100]">
                    </dxo-pager>
                    <dxo-export [enabled]="true" [formats]="['pdf', 'xlsx']">
                    </dxo-export>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>


                    <dxi-column dataField="LedgerName" caption="Ledger Name" dataType="string" alignment="left"
                        [allowFiltering]="true">
                        <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                    </dxi-column>

                    <dxi-column dataField="TransactionDescription" caption="Transaction Description" dataType="string"
                        alignment="left">
                        <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                    </dxi-column>

                    <dxi-column dataField="Merchant" caption="Merchant" dataType="string" alignment="left">
                        <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                    </dxi-column>

                    <dxi-column dataField="Wallet" caption="Wallet" dataType="string" alignment="left">
                        <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                    </dxi-column>

                    <dxi-column dataField="Entry" caption="Entry" dataType="string" width="100px" alignment="left">
                    </dxi-column>

                    <dxi-column dataField="Amount" caption="Amount" dataType="number" [format]="customCurrencyFormat"
                        alignment="right">
                    </dxi-column>

                    <dxi-column dataField="Date" sortOrder="desc" caption="Date" dataType="date"
                        format="yyyy/MM/dd HH:mm:ss" alignment="left">

                    </dxi-column>

                    <dxo-summary>
                        <dxi-total-item column="LedgerName" [customizeText]="customCountFormat" summaryType="count">
                        </dxi-total-item>
                        <dxi-total-item column="Amount" summaryType="sum" [valueFormat]="customCurrencyFormat">
                        </dxi-total-item>
                    </dxo-summary>

                </dx-data-grid>
            </div>
        
    </div>
    
</dx-scroll-view>
</div>
